/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'paper-work': {
    width: 16,
    height: 16,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M987.429 877.714a36.571 36.571 0 110 73.143H585.143a36.571 36.571 0 110-73.143h402.286zM708.023 45.056a36.571 36.571 0 0151.2 4.315l219.428 256a36.571 36.571 0 01-4.388 51.932L315.977 905.874a36.571 36.571 0 01-18.286 8.046l-256 36.571a36.571 36.571 0 01-41.398-40.74l36.571-292.572a36.571 36.571 0 0112.873-23.552zm-139.557 211.53l-460.8 384-28.891 230.692 198.217-28.307 460.434-383.634-168.96-202.752zM987.43 731.428a36.571 36.571 0 110 73.142h-256a36.571 36.571 0 110-73.142h256zm0-146.286a36.571 36.571 0 110 73.143H877.714a36.571 36.571 0 110-73.143H987.43zm-260.316-460.8l-102.4 85.358 168.96 202.752 105.253-87.699-171.813-200.411z"/>'
  }
})
